import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    parentContainer: {
        '& .MuiDialogContent-root': {
            height: 'calc(100% - 15px)',
        }
    },
    formContainer: {
        width: 'calc(100% - 30px)', // 100% (dialog width) - 30px (margin)
        height: 'calc(600px - 120px - 30px)', // 600px (dialog height) - 120px (header and footer) - 30px (margin)
        border: '1px solid #ddd',
        margin: '15px'
    },
    grid: {
        height: '100%',
        width: '100%'
    },
});
